import { useState } from "react";
import { LinkedinLogo, FacebookLogo, InstagramLogo, WhatsappLogo, Envelope, Link as LinkIcon, ShareNetwork, Check, XLogo } from "@phosphor-icons/react";

/**
 * ShareBar — share to LinkedIn, X, Facebook, WhatsApp, Email, Instagram (copy), and Copy link.
 * Props: url (defaults to current page), title, summary
 */
export default function ShareBar({ url, title = "", summary = "" }) {
  const [copied, setCopied] = useState(false);
  const target = url || (typeof window !== "undefined" ? window.location.href : "");
  const enc = encodeURIComponent;
  const sUrl = enc(target);
  const sTitle = enc(title);
  const sSum = enc(summary);

  const targets = [
    {
      key: "linkedin", label: "LinkedIn", Icon: LinkedinLogo, color: "#0A66C2",
      href: `https://www.linkedin.com/sharing/share-offsite/?url=${sUrl}`,
    },
    {
      key: "x", label: "X", Icon: XLogo, color: "#FFFFFF",
      href: `https://twitter.com/intent/tweet?url=${sUrl}&text=${sTitle}`,
    },
    {
      key: "facebook", label: "Facebook", Icon: FacebookLogo, color: "#1877F2",
      href: `https://www.facebook.com/sharer/sharer.php?u=${sUrl}`,
    },
    {
      key: "whatsapp", label: "WhatsApp", Icon: WhatsappLogo, color: "#25D366",
      href: `https://wa.me/?text=${sTitle}%20${sUrl}`,
    },
    {
      key: "email", label: "Email", Icon: Envelope, color: "#A1A1AA",
      href: `mailto:?subject=${sTitle}&body=${sSum}%0A%0A${sUrl}`,
    },
  ];

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(target);
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    } catch (_) {}
  };

  const copyForInstagram = async () => {
    // Instagram has no web share URL — copy link + open Instagram in new tab
    await copyLink();
    window.open("https://www.instagram.com/", "_blank", "noopener");
  };

  return (
    <div className="border border-[#27272A] p-3 flex flex-wrap items-center gap-2" data-testid="share-bar">
      <span className="label-mono mr-1 flex items-center gap-1.5">
        <ShareNetwork size={11} weight="bold" style={{ color: "#E60012" }} /> SHARE
      </span>
      {targets.map((t) => (
        <a
          key={t.key}
          href={t.href}
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-ghost btn-sm"
          title={t.label}
          data-testid={`share-${t.key}`}
        >
          <t.Icon size={13} weight="fill" style={{ color: t.color }} />
        </a>
      ))}
      <button onClick={copyForInstagram} className="btn btn-ghost btn-sm" title="Copy link & open Instagram" data-testid="share-instagram">
        <InstagramLogo size={13} weight="fill" style={{ color: "#E1306C" }} />
      </button>
      <button onClick={copyLink} className="btn btn-ghost btn-sm" title="Copy link" data-testid="share-copy">
        {copied ? <Check size={13} weight="bold" style={{ color: "#00E676" }} /> : <LinkIcon size={13} weight="bold" />}
      </button>
      {copied && <span className="label-mono" style={{ color: "#00E676" }}>LINK COPIED</span>}
    </div>
  );
}
